/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { showLogin } from '../../actions/login';
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';

const LoginButton = ({ toggleRequestDemoModal }: { toggleRequestDemoModal: () => void }) => {

  const handleShowLogin = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    showLogin();
  }

  return (
    <>
      <div className='d-block d-md-none'>
        <UncontrolledButtonDropdown>
          <DropdownToggle outline className='px-2' caret>
            <i className='fal fa-bars' />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={toggleRequestDemoModal}>
              <i className='fal fa-envelope me-2' />
              Contact Us
            </DropdownItem>
            <DropdownItem onClick={handleShowLogin}>
              <i className='fal fa-sign-in-alt me-2' />
              Log in
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      </div>
      <div className='d-none d-md-flex h-100 align-items-center'>
        <div>
          <Button color='link' className='border-start register-btn text-nowrap' onClick={toggleRequestDemoModal}>
            Contact Us
          </Button>
        </div>
        <div>
          <Button color='primary' className='login-btn mr-3 text-nowrap' onClick={handleShowLogin}>
            Log in
          </Button>
        </div>
      </div>
    </>
  );
}

export default LoginButton;
